/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询已经设置的本次观演人列表与限购数量
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.ProductCommonlyDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/product-commonly/${productId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
